import { FC } from "react";
import { useParams } from "react-router-dom";
import { ErrorFallback, Loader } from "@/components";
import { SingleNewsUI } from "./SingleNews.ui";
import useSingleNews from "../../hooks/useSingleNews";
import { Theme } from "@radix-ui/themes";
import { themeMap, themeRadiusMap } from "@/utils/constants/Themes";
import useSetClient from "@/hooks/useSetClient";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

export const SingleNews: FC = (): JSX.Element => {
  const { slug, zoneId } = useParams();

  const { zoneItem, loadingZone } = useSetClient(zoneId);
  const { newsItem, loading, error } = useSingleNews(slug);

  const theme =
    themeMap[zoneItem?.theme.toUpperCase()] ||
    themeMap[brand.brandTheme.toUpperCase()] ||
    "violet";
  const radius = themeRadiusMap[zoneItem?.theme.toUpperCase()] || "none";

  if (error) {
    return <ErrorFallback>Failed to load news article</ErrorFallback>;
  }

  if (loadingZone || loading) {
    return <Loader />;
  }

  if (zoneId) {
    return (
      <Theme appearance="dark" accentColor={theme} radius={radius}>
        <SingleNewsUI data={newsItem as any} />
      </Theme>
    );
  }

  return <SingleNewsUI data={newsItem as any} />;
};
